<!-- 添加/修改矿山，bluesky:2023-09-30 -->
<template>
  <div class="add-or-edit-section">
    <el-form :label-position="'right'" label-width="100px" :model="formData" :rules="rules" ref="form">
        <el-form-item label="名称:" prop="name">
            <el-input v-model="formData.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="省市区：" prop="code">
          <el-cascader
                id="areaSelect"
                size="large"
                :options="options"
                v-model="selectedOptions"
                @change="handleChange">
          </el-cascader>
        </el-form-item>

        <el-form-item label="采矿权人:" prop="owner">
            <el-input v-model="formData.owner" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="开采矿种:" prop="ore">
            <el-input v-model="formData.ore" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="生产规模:" prop="scale">
            <el-input v-model="formData.scale" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="有效期限开始日期:" prop="startTime">
            <el-input format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" class="date-input" type="date" v-model="formData.startTime" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="有效期限结束日期:" prop="endTime">
            <el-input format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" class="date-input" type="date" v-model="formData.endTime" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="开采方式:" prop="exploitateStyle">
            <el-input v-model="formData.exploitateStyle" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="坐标经度:" prop="longitude">
            <el-input v-model="formData.longitude" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="坐标纬度:" prop="latitude">
            <el-input v-model="formData.latitude" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="地图ID(多个时用逗号隔开):" prop="mapIdList">
            <el-input :rows="4" type="textarea" v-model="formData.mapIdList" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="地图AppId:" prop="latitude">
            <el-input v-model="formData.mapAppId" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="地图App密钥:" prop="latitude">
            <el-input v-model="formData.mapAppKey" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="三维地图ID:" prop="mapId">
            <el-input :rows="4" type="textarea" v-model="formData.map3dId" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="三维地图AppId:" prop="latitude">
            <el-input v-model="formData.map3dAppId" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="三维地图App密钥:" prop="latitude">
            <el-input v-model="formData.map3dAppKey" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item>
            <el-checkbox v-model="statusBool">是否启用</el-checkbox>
        </el-form-item>

        <div>
          <div slot="footer" class="dialog-footer-in-form">
            <el-button plain @click="close">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
          </div>
        </div>

    </el-form>
  </div>
</template>

<script>
  import { regionData,CodeToText,TextToCode  } from 'element-china-area-data'
export default {
    props:{
        idInput:null,
    },
    created(){
    	this.formData.id = this.idInput;
    	//如果idInput不为空，表示修改
    	if(this.idInput && this.idInput != null){
    		this.getItem();
    	}
      else{
        this.initArea();
      }
    },
    watch:{
      statusBool(newVal){
        this.formData.status = newVal ? 1 : 0;
      },
    },
    data(){
        return {
            formData: {
              id:null,// 矿山ID
              name:null,// 矿山名称
              province:null,// 矿山所属省份
              city:null,// 矿山所属城市
              district:null,// 矿山所属区县
              owner:null,// 采矿权人
              ore:null,// 开采矿种
              scale:null,// 生产规模
              startTime:null,// 有效期限开始日期
              endTime:null,// 有效期限结束日期
              exploitateStyle:null,// 开采方式
              status:1,// 状态

              // 地图相关配置
              // bluesky:2024-04-14
              longitude:null,
              latitude:null,
              mapIdList:null,
              mapAppId:null,
              mapAppKey:null,
              map3dId:null,
              map3dAppId:null,
              map3dAppKey:null,
            },
            statusBool:true,//status的配套临时变量
            rules:{
                name:{required:true,message:'名称不能为空',trigger:'blur'},
                province:{required:true,message:'矿山所属省份不能为空',trigger:'blur'},
                city:{required:true,message:'矿山所属城市不能为空',trigger:'blur'},
                district:{required:true,message:'矿山所属区县不能为空',trigger:'blur'},
                owner:{required:true,message:'采矿权人不能为空',trigger:'blur'},
                ore:{required:true,message:'开采矿种不能为空',trigger:'blur'},
                scale:{required:true,message:'生产规模不能为空',trigger:'blur'},
                startTime:{required:true,message:'有效期限开始日期不能为空',trigger:'blur'},
                endTime:{required:true,message:'有效期限结束日期不能为空',trigger:'blur'},
                exploitateStyle:{required:true,message:'开采方式不能为空',trigger:'blur'},
            },
            options: regionData ,
            selectedOptions: [],
        }
    },
    methods:{
      // 初始化默认地区
      initArea(){
        this.formData.province = "湖南省";
        this.formData.city = "郴州市";
        this.formData.district = "汝城县";
        this.selectedOptions = this.$utils.textToCode(TextToCode,this.formData);
      },
      getItem(){
        this.$apis.get('/admin/mine/get', {
          id:this.formData.id
        }).then(res => {
          if(res.data.code == 200){
            this.formData = res.data.data;
            this.statusBool = this.formData.status == 1;

            // 默认选中省市区联动下拉列表，选中前需要调用TextToCode转换为代号才能识别
            let tmpList = this.$utils.textToCode(TextToCode,res.data.data);
            this.selectedOptions = tmpList;
            console.log("selectedOptions",tmpList);
          }
          else{
            this.$message({
              type: 'error',
              message: `${res.data.data}`
            });
          }
        });
      },

      submit(){
        //验证rules
        this.$refs.form.validate(async (valid)=>{
          console.log(valid)
          if(valid){
            let url = this.formData.id && this.formData.id != "" ? "/admin/mine/update" : "/admin/mine/add";
            this.$apis.post(url, this.formData).then(res => {
              if(res.data.code == 200){
                this.formData = res.data.data;
                this.$emit("success");
                this.$message({
                  type: 'success',
                  message: `操作成功！`
                });
              }
              else{
                this.$message({
                  type: 'error',
                  message: `${res.data.data}`
                });
              }
            });
          }
        });
      },
      // 关闭
      close(){
        this.$emit("close");
      },
      // 省市区改变
          handleChange (value) {
              console.log(value)

                if (
                  value[0] != null &&
                  value[1] != null &&
                  value[2] != null
                ) {
                  this.formData.province = CodeToText[value[0]];
                  this.formData.city = CodeToText[value[1]];
                  this.formData.district = CodeToText[value[2]];

                  const str =
                    CodeToText[value[0]] +
                    '/' +
                    CodeToText[value[1]] +
                    '/' +
                    CodeToText[value[2]]
                  console.log(str)
                }
                }

    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/components/addOrEditMine.vue